import "./Header_styles.css"

const AppHeader = () => {
  return(<header className="headd">
      <img className="logo" src="WebLogo.png" alt="Кудияр" />
      <div className="thaste">На твоей стороне вкуса</div>
  </header>)
}
export default AppHeader